import { render, staticRenderFns } from "./BasicConfiguration.vue?vue&type=template&id=691bae4b&scoped=true"
import script from "./BasicConfiguration.vue?vue&type=script&lang=js"
export * from "./BasicConfiguration.vue?vue&type=script&lang=js"
import style0 from "./BasicConfiguration.vue?vue&type=style&index=0&id=691bae4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691bae4b",
  null
  
)

export default component.exports